import { render, staticRenderFns } from "./complexSelect.vue?vue&type=template&id=924462ec"
import script from "./complexSelect.vue?vue&type=script&lang=js"
export * from "./complexSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports